import { Component } from '@angular/core';
import { LoaderService } from 'src/app/main/service/interceptors/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  isLoading = this.loaderService.loader$;

  constructor(private loaderService: LoaderService) {}
}
